import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'astroturf/react';
import { Components } from 'global';
import CreateWorkCollectionModal from './create_work_collection_modal';
import {
  MainCtaButton,
  InactiveCtaButton,
} from './create_work_collection_modal';

class WorkCollectionForm extends Component {
  static propTypes = {
    addToList: PropTypes.func,
    openCreateListModal: PropTypes.func,
    workCollectionsWithWorks: PropTypes.objectOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        work_count: PropTypes.number,
        works: PropTypes.array,
      }),
    ),
  };

  constructor(props) {
    super(props);
    this.state = { value: '' };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCreateList = this.handleCreateList.bind(this);
  }

  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  handleSubmit(e) {
    if (this.state.value !== '') {
      this.props.addToList(this.state.value);
    }
    e.preventDefault();
  }

  handleCreateList(e) {
    this.props.openCreateListModal();
    e.preventDefault();
  }

  render() {
    return (
      <form>
        Lists:
        <select
          ref={(ref) => {
            if (ref) {
              // setTimeout is used to work around focus() not functioning immediately
              setTimeout(() => {
                ref.focus();
              }, 5);
            }
          }}
          onChange={this.handleChange}
          style={{
            width: '100%',
            margin: '8px 0',
          }}
        >
          <option value="">Select a list</option>
          {Object.values(this.props.workCollectionsWithWorks).map((wc) => {
            return (
              <option key={wc.id} value={wc.id}>
                {wc.name}
              </option>
            );
          })}
        </select>
        <SecondaryCtaButton onClick={this.handleCreateList}>
          <i className="fa fa-plus" style={{ marginRight: '6px' }}></i>
          Create new list
        </SecondaryCtaButton>
        {this.state.value ? (
          <MainCtaButton onClick={this.handleSubmit}>
            <i className="fa fa-check" style={{ marginRight: '6px' }}></i>
            Add to List
          </MainCtaButton>
        ) : (
          <InactiveCtaButton onClick={this.handleSubmit}>
            <i className="fa fa-check" style={{ marginRight: '6px' }}></i>
            Add to List
          </InactiveCtaButton>
        )}
      </form>
    );
  }
}

export default class AddPaperToWorkCollectionModal extends Component {
  static propTypes = {
    closeModal: PropTypes.func,
    workId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    workTitle: PropTypes.string,
    startAddingItemToCollection: PropTypes.func,
    createWorkCollection: PropTypes.func,
    workCollectionsWithWorks: PropTypes.objectOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        work_count: PropTypes.number,
        works: PropTypes.array,
      }),
    ),
  };

  constructor(props) {
    super(props);

    this.handleAddToList = this.handleAddToList.bind(this);
    this.openCreateListModal = this.openCreateListModal.bind(this);
  }

  render() {
    return (
      <div>
        <span style={{ float: 'right' }} onClick={this.props.closeModal}>
          <i
            className="fa fa-times"
            style={{
              cursor: 'pointer',
              margin: '8px 8px 0 0',
              fontSize: '18px',
            }}
          ></i>
        </span>
        <div style={{ width: '70%', margin: '0 auto', padding: '16px 0' }}>
          <div
            style={{
              textAlign: 'center',
              fontSize: '22px',
              margin: '24px 0 24px 0',
              color: '#000',
              fontWeight: '500',
              lineHeight: '1.2',
            }}
          >
            Add paper &ldquo;<i>{this.props.workTitle}</i>&rdquo; to a List
          </div>
          <WorkCollectionForm
            addToList={this.handleAddToList}
            openCreateListModal={this.openCreateListModal}
            workCollectionsWithWorks={this.props.workCollectionsWithWorks}
          />
        </div>
      </div>
    );
  }

  handleAddToList(listId) {
    this.props.startAddingItemToCollection(
      this.props.workId,
      listId,
      this.props.workCollectionsWithWorks[listId].name,
    );
    this.props.closeModal();
  }

  openCreateListModal() {
    let createWorkCollectionAndAddItem = (data) => {
      return this.props.createWorkCollection(data, this.props).then((res) => {
        this.props.startAddingItemToCollection(
          this.props.workId,
          res.work_collection.id,
          res.work_collection.name,
        );
        return res;
      });
    };
    createWorkCollectionAndAddItem = createWorkCollectionAndAddItem.bind(this);
    Components.Utils.showModal(CreateWorkCollectionModal, {
      createWorkCollection: createWorkCollectionAndAddItem,
    });
    this.props.closeModal();
  }
}

const SecondaryCtaButton = styled.button`
  color: hsla(217.72277227722773, 91.82%, 43.14%, 1);
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border-style: none;
  cursor: pointer;
  margin: 8px 0;
  font-weight: bold;
  background-color: hsla(219.99999999999997, 75%, 95.29%, 1);

  &:hover {
    border-color: rgb(164, 191, 238);
    background-color: rgb(242, 244, 255);
  }

  &:active {
    background-color: rgb(217, 230, 252);
    border-color: rgb(217, 230, 252);
  }
`;
